import React, { Component } from 'react'
import { inject, observer, propTypes as mobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'

import Button from '@components/Button'
import Star from '@components/Icon/Star'
import Pagination from '@components/Pagination'

const colors = [
  '#F6A623', // 0 gray
  '#a91f24', // 1 gray
  '#a81c25', // 2 gray
  '#c11b24', // 3 gray
  '#d51f24', // 4 gray
  '#e5312a', // 5 gray
  '#e74f17', // 6 gray
  '#f29200', // 7 gray
  '#f9b131', // 8 gray
  '#97c022', // 9 gray
  '#3aaa34' // 10 gray
]

class ClientFeedback extends Component {
  static propTypes = {
    feedbacks: PropTypes.object,
    modalStore: PropTypes.object
  }

  state = {
    page: 1,
    items: this.props.feedbacks.slice(0, 1)
  }

  changePage = page => {
    const { feedbacks, perPage } = this.props
    const from = (page - 1) * perPage
    const to = page * perPage
    this.setState({
      page: page,
      items: feedbacks.slice(from, to)
    })
  }

  render () {
    const { project, feedbacks, modalStore, staticData } = this.props
    let questions = []
    if (project) {
      questions = staticData.getClientProjectFeedbackQuestions(
        project.projectTypeId
      )
    }
    return (
      <div className='expert-form'>
        {this.state.items.map((feedback, index) => {
          if (!project) {
            questions = staticData.getClientProjectFeedbackQuestions(
              feedback.projectTypeId
            )
          }
          const client = feedback.client
            ? feedback.client.fullName
            : feedback.fullName
          const projectName = project
            ? project.projectName
            : feedback.projectName
          return (
            <div key={feedback.id + index}>
              <h1 className='expert-form__title'>
                Feedback {client ? `from client ${client}` : ''}{' '}
                {projectName ? `on project ${projectName}` : ''}
                <div className='expert-form__subtitle--with-action'>
                  <Star fillColor={colors[ Math.floor(feedback.averageRating) ]} />
                  {feedback.averageRating
                    ? feedback.averageRating.toFixed(2)
                    : 'N/A'}
                </div>
              </h1>
              {questions.map((q, i) => (
                <div key={q.questionName} className='expert-form__section'>
                  <h2 className='expert-form__subtitle--with-action m-t-0 m-b-xxl'>
                    {q.questionName}
                    <div className='expert-form__subtitle--with-action'>
                      <Star fillColor={

                        colors[Math.floor(feedback[`rating${i + 1}`] || 0)]
                      }/>
                      {feedback[`rating${i + 1}`]
                        ? feedback[`rating${i + 1}`].toFixed(2)
                        : 'N/A'}
                    </div>
                  </h2>
                  <div className='expert-form__input-group'>
                    <label className='expert-form__label expert-form__label--reset-line-height'>
                      Question
                    </label>
                    <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
                      <b>{q.question}</b>
                    </div>
                  </div>
                  <div className='expert-form__input-group'>
                    <label className='expert-form__label expert-form__label--reset-line-height'>
                      Comment
                    </label>
                    <div className='expert-form__input-wrapper expert-form__input-wrapper--wide'>
                      {feedback[`comment${i + 1}`] || 'N/A'}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        })}
        <Pagination
          total={feedbacks.length}
          perPage={this.props.perPage}
          page={this.state.page}
          onChange={this.changePage}
        />
        <div className='expert-form__section'>
          <Button
            className='position-absolute'
            secondary
            onClick={modalStore.close}
          >
            Close
          </Button>
        </div>
      </div>
    )
  }
}

ClientFeedback.propTypes = {
  perPage: PropTypes.number,
  feedbacks: mobxPropTypes.observableArray,
  project: PropTypes.object,
  modalStore: PropTypes.object,
  staticData: PropTypes.object
}

ClientFeedback.defaultProps = {
  perPage: 1,
  feedbacks: [],
  hideButtons: true
}

export default inject('modalStore', 'staticData')(observer(ClientFeedback))
